import $ from 'jquery';

export default function validateForm(form) {
  let valid = true;
  const inputs = $(form).find("input[type='text'], input[type='email']");

  clearErrors(form);

  inputs.each((index, el) => {
    if ($(el).attr('required') && $(el).val() === '') {
      $(el)
        .closest('.input')
        .addClass('input--error');
      valid = false;
    }
  });

  return valid;
}

function clearErrors(form) {
  $(form).find('.input--error').removeClass('input--error');
}
